import { useContext, useCallback } from 'react';

import { GlobalStateContext } from '../../../contexts/GlobalState';
import { globalStateActionType } from '../../../contexts/GlobalState/reducer';

import { msLoginPopup } from '../../../authProviders/microsoft';


export function MicrosoftSignInButton({
    setIsSigningIn, setSignInError
}) {
    const [, dispatch] = useContext(GlobalStateContext);

    const onLoginClick = useCallback(
        (_evt) => {
            setIsSigningIn(true);

            msLoginPopup()
                .then((cwTokens) => {
                    setSignInError(null);

                    dispatch({
                        type: globalStateActionType.SIGNIN,
                        value: {
                            ...cwTokens
                        }
                    });
                })
                .catch((err) => {
                    setSignInError(err);
                })
                .finally(() => {
                    setIsSigningIn(false);
                });
        },
        [dispatch, setIsSigningIn, setSignInError]
    );

    return (
        <button
            type="button"
            className="cw-SignInScreen__ms-btn"
            onClick={onLoginClick}
            aria-label="Sign in with Microsoft"
        >
            <svg
                className="cw-SignInScreen__ms-btn-logo"
                viewBox="0 0 23 23"
                aria-hidden="true"
            >
                <rect x="1" y="1" width="10" height="10" fill="#F25022" />
                <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
                <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
                <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
            </svg>
            <span className="cw-SignInScreen__ms-btn-label">Sign in with Microsoft</span>
            <svg
                className="cw-SignInScreen__ms-btn-arrow"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                aria-hidden="true"
            >
                <path
                    d="M3 8h9.5M9 4.5 12.5 8 9 11.5"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </button>
    );
}
